module.exports = __webpack_public_path__ + "img/k_heart.4023bee0.jpg";